if (!customElements.get('dod-paired-product')) {
  customElements.define(
    'dod-paired-product',
    class DodPairedProduct extends HTMLElement {
      connectedCallback() {
        const sku = this.dataset.sku;
        if (!sku) return;

        fetch(`/search?q=${encodeURIComponent(sku)}&type=product`, {
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        })
          .then((response) => response.text())
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const dataTag = doc.querySelector('script#search-product-swatch-data');
            if (!dataTag) return;

            const products = JSON.parse(dataTag.textContent);
            const match = products.find((entry) => entry.sku === sku);
            if (match) this.populate(match);
          })
          .catch((error) => console.error('dod-paired-product:', error));
      }

      decodeHTMLEntities(str) {
        const el = document.createElement('textarea');
        el.innerHTML = str || '';
        return el.value;
      }

      populate(item) {
        const title = this.decodeHTMLEntities(item.title);
        const vendor = this.decodeHTMLEntities(item.vendor);

        const headline = title.includes('(Blemished Box)')
          ? 'Get it for less! The perfect product in an imperfect box.'
          : 'Buying as a gift? This product is available in a perfect box!';

        this.querySelector('.product-headline').textContent = headline;

        const img = this.querySelector('img');
        img.src = item.image_large;
        img.alt = title;

        this.querySelector('.product-vendor').textContent = vendor;

        const titleLink = this.querySelector('.product-title');
        titleLink.textContent = title;
        titleLink.href = item.url;

        this.querySelector('.compare-price').textContent = item.compare_at_price;
        this.querySelector('.regular-price').textContent = item.price;
        this.querySelector('input[name="id"]').value = item.variant_id;

        if (item.available) this.classList.remove('hidden');
      }
    }
  );
}
